import {
  DataField,
  Divider,
  H2,
  H3,
  Section,
  P,
  CheckList,
} from "./common-components";

export const ConsultedSourcesCheckList = ({ formType, documentation }) => {
  let reasons = [{ label: "Pharmacy profile", checked: false},
{ label: "Physician", checked: false},
{ label: "Nurse Practitioner", checked: false},
{ label: "Patient", checked: false},
{ label: "Caregiver/ Agent/ Family", checked: false},
{ label: "Medication Packages/ Compliance or Blister Package", checked: false},
{ label: "Laboratory/ Test Values", checked: false},
{ label: "Electronic health record", checked: false},
{ label: "Hospital/ other facility", checked: false}];

  const autoCheckedKeys = new Set(["pharmacy profile", "patient"]);
  const consulted = documentation?.consultedSources ?? [];
  const checklistSet = new Set(consulted.map((item) => String(item).trim().toLowerCase()));

  let updatedReasons = reasons.map((reason) => {
    const key = reason.label.trim().toLowerCase();
    const checked = autoCheckedKeys.has(key) || checklistSet.has(key);
    return {
      ...reason,
      checked,
      label: reason.label === "Hospital/ other facility" ? `Hospital/ other facility: ${documentation?.consultedSourcesComments ?? ""}` : reason.label,
    };
  });

  return (
    <Section formType={formType}>
      <H2>Sources Consulted for Service</H2>
      <div className="flex flex-col gap-1">
        <CheckList list={updatedReasons} />
      </div>
    </Section>
  );
};
